import React from 'react'
import { useId } from 'react';

const Sort = ({ setSorting, columnName, setSortOption = null, setSortDefault = "", sortByLabel = 'Sort by' }) => {
    const filter = ( options ) => {
        switch (options) {
            case 'asc':
            setSorting([{ id: columnName, asc: true }])
            break;
            case 'desc':
            setSorting([{ id: columnName, desc: true }])
            break;
            default:
            setSorting([])
            break;
        }
    }
    const option = setSortOption !== null ? setSortOption : { asc: 'Name A-Z', desc: 'Name Z-A' }
    const hasDefaultOption = setSortDefault !== '';
    const controlID = useId()
    return (
        <div className="msync-form__group">
            <label className="msync-visually-hidden" for={ controlID }>{ sortByLabel }</label>
            <select 
                onChange={ (e) => filter( String( e.target.value ) ) } 
                defaultValue={ setSortDefault }
                id={ controlID }
            >
                {!hasDefaultOption && (
                    <option value="" disabled>
                        {sortByLabel}
                    </option>
                )}
                <option value="asc">{hasDefaultOption ? `${sortByLabel}: ${option.asc}` : option.asc}</option>
                <option value="desc">{hasDefaultOption ? `${sortByLabel}: ${option.desc}` : option.desc}</option>
            </select>
        </div>
    )
}

export default Sort
